import { render, staticRenderFns } from "./LiquidationByMonths.vue?vue&type=template&id=c2554156&"
import script from "./LiquidationByMonths.vue?vue&type=script&lang=js&"
export * from "./LiquidationByMonths.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports